export const VIRTUAL_BASKET_LINE_BENEFIT_TYPE = "tsicommon.offer.benefits.GiftWithPurchasePostCheckoutBenefit" as const;
export const CI_COMMIT_SHA = "97faea570a753ad2ec0785dd22746a09a8b359fe" as const;
export const CI_COMMIT_REF_SLUG = "localdev" as const;
export const constants = {
        "thelabui.fields.week.Weekday": {
            "MONDAY": 1,
            "TUESDAY": 2,
            "WEDNESDAY": 3,
            "THURSDAY": 4,
            "FRIDAY": 5,
            "SATURDAY": 6,
            "SUNDAY": 7
        },
        "tsicommon.cms.blocks.sub_blocks.responsive_visibility.ResponsiveVisibilityRules": {
            "DEFAULT": "",
            "SMALL_ONLY": "responsive-visibility--small-only",
            "MEDIUM_ONLY": "responsive-visibility--medium-only",
            "MEDIUM_AND_SMALLER": "responsive-visibility--medium-and-smaller",
            "MEDIUM_AND_LARGER": "responsive-visibility--medium-and-larger",
            "LARGE_ONLY": "responsive-visibility--large-only"
        },
        "tsicommon.cms.blocks.sub_blocks.spacing.SpacingRules": {
            "DEFAULT": "",
            "XS": "spacing--xtra-small",
            "S": "spacing--small",
            "M": "spacing--medium",
            "L": "spacing--large",
            "XL": "spacing--xtra-large"
        },
        "tsicommon.cms.models.rich_navigation.RichNavigationVariantOptions": {
            "DEFAULT": "",
            "TWO_THIRDS_LINK": "rich-navigation--link-collection--two-thirds-link",
            "SINGLE_COLUMN": "rich-navigation--link-collection--single-column",
            "HEART": "rich-navigation--link-collection--heart",
            "NO_TITLE": "rich-navigation--link-collection--no-title",
            "INSPIRATION": "rich-navigation--link-collection--inspiration"
        },
        "tsicommon.financing.constants.HousingStatus": {
            "RENT": "Rent",
            "OWN": "Own",
            "OTHER": "Other"
        },
        "tsicommon.financing.constants.CreditAppStatus": {
            "UNKNOWN": "",
            "OFFERED": "OFFERED",
            "APPROVED": "APPROVED",
            "PENDING": "PENDING",
            "DENIED": "DENIED",
            "ERROR": "ERROR",
            "EXISTING_CARDHOLDER": "EC"
        },
        "tsicommon.financing.constants.DocumentType": {
            "SUMMARY_OF_CREDIT_TERMS": "SUMMARY_OF_CREDIT_TERMS",
            "OPT_OUT": "OPT_OUT",
            "CARDHOLDER_AGREEMENT": "CARDHOLDER_AGREEMENT",
            "AUTO_DEDUCT_DISCLOSURE": "AUTO_DEDUCT_DISCLOSURE",
            "CONSENT_TO_ELECTRONIC_DISCLOSURE": "CONSENT_TO_ELECTRONIC_DISCLOSURE",
            "APPLICATION_DISCLOSURE": "APPLICATION_DISCLOSURE"
        },
        "tsicommon.financing.constants.DocumentFormat": {
            "PDF": "application/pdf",
            "HTML": "text/html"
        },
        "tsicommon.financing.constants.EmploymentStatus": {
            "EMPLOYED": "Employed",
            "SELF_EMPLOYED": "Self Employed",
            "RETIRED": "Retired",
            "UNEMPLOYED_WITH_INCOME": "Unemployed with income",
            "UNEMPLOYED_WITHOUT_INCOME": "Unemployed without income"
        },
        "tsicommon.financing.constants.CitizenshipStatus": {
            "US_CITIZEN": "U.S. Citizen",
            "US_PERMANENT_RESIDENT": "U.S. Lawful Permanent Resident",
            "NON_RESIDENT_ALIEN": "Non-Resident Alien"
        },
        "tsicommon.financing.constants.CountryChoices": {
            "US": "US",
            "AF": "AF",
            "AX": "AX",
            "AL": "AL",
            "DZ": "DZ",
            "AS": "AS",
            "AD": "AD",
            "AO": "AO",
            "AI": "AI",
            "AQ": "AQ",
            "AG": "AG",
            "AR": "AR",
            "AM": "AM",
            "AW": "AW",
            "AU": "AU",
            "AT": "AT",
            "AZ": "AZ",
            "BS": "BS",
            "BH": "BH",
            "BD": "BD",
            "BB": "BB",
            "BY": "BY",
            "BE": "BE",
            "BZ": "BZ",
            "BJ": "BJ",
            "BM": "BM",
            "BT": "BT",
            "BO": "BO",
            "BA": "BA",
            "BW": "BW",
            "BV": "BV",
            "BR": "BR",
            "IO": "IO",
            "BN": "BN",
            "BG": "BG",
            "BF": "BF",
            "BI": "BI",
            "KH": "KH",
            "CM": "CM",
            "CA": "CA",
            "CV": "CV",
            "KY": "KY",
            "CF": "CF",
            "TD": "TD",
            "CL": "CL",
            "CN": "CN",
            "CX": "CX",
            "CC": "CC",
            "CO": "CO",
            "KM": "KM",
            "CG": "CG",
            "CD": "CD",
            "CK": "CK",
            "CR": "CR",
            "CI": "CI",
            "HR": "HR",
            "CU": "CU",
            "CY": "CY",
            "CZ": "CZ",
            "DK": "DK",
            "DJ": "DJ",
            "DM": "DM",
            "DO": "DO",
            "EC": "EC",
            "EG": "EG",
            "SV": "SV",
            "GQ": "GQ",
            "ER": "ER",
            "EE": "EE",
            "ET": "ET",
            "FK": "FK",
            "FO": "FO",
            "FJ": "FJ",
            "FI": "FI",
            "FR": "FR",
            "GF": "GF",
            "PF": "PF",
            "TF": "TF",
            "GA": "GA",
            "GM": "GM",
            "GE": "GE",
            "DE": "DE",
            "GH": "GH",
            "GI": "GI",
            "GR": "GR",
            "GL": "GL",
            "GD": "GD",
            "GP": "GP",
            "GU": "GU",
            "GT": "GT",
            "GG": "GG",
            "GN": "GN",
            "GW": "GW",
            "GY": "GY",
            "HT": "HT",
            "HM": "HM",
            "VA": "VA",
            "HN": "HN",
            "HK": "HK",
            "HU": "HU",
            "IS": "IS",
            "IN": "IN",
            "ID": "ID",
            "IR": "IR",
            "IQ": "IQ",
            "IE": "IE",
            "IM": "IM",
            "IL": "IL",
            "IT": "IT",
            "JM": "JM",
            "JP": "JP",
            "JE": "JE",
            "JO": "JO",
            "KZ": "KZ",
            "KE": "KE",
            "KI": "KI",
            "KP": "KP",
            "KR": "KR",
            "KW": "KW",
            "KG": "KG",
            "LA": "LA",
            "LV": "LV",
            "LB": "LB",
            "LS": "LS",
            "LR": "LR",
            "LY": "LY",
            "LI": "LI",
            "LT": "LT",
            "LU": "LU",
            "MO": "MO",
            "MK": "MK",
            "MG": "MG",
            "MW": "MW",
            "MY": "MY",
            "MV": "MV",
            "ML": "ML",
            "MT": "MT",
            "MH": "MH",
            "MQ": "MQ",
            "MR": "MR",
            "MU": "MU",
            "YT": "YT",
            "MX": "MX",
            "FM": "FM",
            "MD": "MD",
            "MC": "MC",
            "MN": "MN",
            "MS": "MS",
            "MA": "MA",
            "MZ": "MZ",
            "MM": "MM",
            "NA": "NA",
            "NR": "NR",
            "NP": "NP",
            "NL": "NL",
            "AN": "AN",
            "NC": "NC",
            "NZ": "NZ",
            "NI": "NI",
            "NE": "NE",
            "NG": "NG",
            "NU": "NU",
            "NF": "NF",
            "MP": "MP",
            "NO": "NO",
            "OM": "OM",
            "PK": "PK",
            "PW": "PW",
            "PS": "PS",
            "PA": "PA",
            "PG": "PG",
            "PY": "PY",
            "PE": "PE",
            "PH": "PH",
            "PN": "PN",
            "PL": "PL",
            "PT": "PT",
            "PR": "PR",
            "QA": "QA",
            "RE": "RE",
            "RO": "RO",
            "RU": "RU",
            "RW": "RW",
            "SH": "SH",
            "KN": "KN",
            "LC": "LC",
            "PM": "PM",
            "VC": "VC",
            "WS": "WS",
            "SM": "SM",
            "ST": "ST",
            "SA": "SA",
            "SN": "SN",
            "CS": "CS",
            "SC": "SC",
            "SL": "SL",
            "SG": "SG",
            "SK": "SK",
            "SI": "SI",
            "SB": "SB",
            "SO": "SO",
            "ZA": "ZA",
            "GS": "GS",
            "ES": "ES",
            "LK": "LK",
            "SD": "SD",
            "SR": "SR",
            "SJ": "SJ",
            "SZ": "SZ",
            "SE": "SE",
            "CH": "CH",
            "SY": "SY",
            "TW": "TW",
            "TJ": "TJ",
            "TZ": "TZ",
            "TH": "TH",
            "TL": "TL",
            "TG": "TG",
            "TK": "TK",
            "TO": "TO",
            "TT": "TT",
            "TN": "TN",
            "TR": "TR",
            "TM": "TM",
            "TC": "TC",
            "TV": "TV",
            "UG": "UG",
            "UA": "UA",
            "AE": "AE",
            "GB": "GB",
            "UM": "UM",
            "UY": "UY",
            "UZ": "UZ",
            "VU": "VU",
            "VE": "VE",
            "VN": "VN",
            "VG": "VG",
            "VI": "VI",
            "WF": "WF",
            "EH": "EH",
            "YE": "YE",
            "ZM": "ZM",
            "ZW": "ZW"
        },
        "VIRTUAL_BASKET_LINE_BENEFIT_TYPE": "tsicommon.offer.benefits.GiftWithPurchasePostCheckoutBenefit",
        "CI_COMMIT_SHA": "97faea570a753ad2ec0785dd22746a09a8b359fe",
        "CI_COMMIT_REF_SLUG": "localdev"
    } as const;
